import {
  Form_Scoring_Policies_Enum as FormScoringPolicies,
  Form_Types_Enum as FormTypes,
  Form_Question_Types_Enum as QuestionTypes,
  Form_Question_Submission_States_Enum as QuestionSubmissionState,
  Form_Submission_Statuses_Enum as FormSubmissionStatusesEnum,
} from '@lyon/graphql/types';

export interface IProviderFormsResult {
  readonly id: string;
  readonly title: string;
  readonly description?: string;
}

export interface IFormsResult {
  readonly id: string;
  readonly title: string;
  readonly description?: string | null;
  readonly type: FormTypes;
  readonly canGoBack: boolean;
  readonly shuffleQuestion: boolean;
  readonly textSelection: boolean;
  readonly timeLimit?: number | null;
  readonly allowedAttempts?: number | null;
  readonly scoringPolicy: FormScoringPolicies;
  readonly showScore: boolean;
  readonly showCorrectResponse: boolean;
  readonly showRankPercentile: boolean;
  readonly showAfterRegrade: boolean;
  readonly oneTimeResult: boolean;
  readonly isLocked: boolean;
  readonly isPractice: boolean;
  readonly accessCode?: string | null;
}

export interface IFormQuestionsResult {
  readonly id: string;
  readonly name: string;
  readonly type: QuestionTypes;
  readonly position: number;
  readonly caption?: string | null;
  readonly isOpenEnded: boolean;
  readonly pointsPossible: number;
  readonly answerCount: number;
  readonly isCaseSensitive: boolean;
  readonly correctFeedback?: string | null;
  readonly incorrectFeedback?: string | null;
  readonly indeterminateFeedback?: string | null;
}

export interface IFormQuestionAnswersResult {
  readonly id: string;
  readonly name: string;
  readonly feedback?: string | null;
  readonly points: number;
}

export interface IFormSubmissionsResult {
  readonly id: string;
  readonly formId: string;
  readonly userId: string;
  readonly startedAt: Date;
  readonly finishedAt?: Date;
  readonly deadlineAt?: Date;
  readonly status: FormSubmissionStatusesEnum;
  readonly attempt: number;
}

export interface IFormSubmissionDetails {
  id: string;
  attempt: number;
  finishedAt?: Date;
  startedAt: Date;
  initialTotalScore: number;
  finalTotalScore: number | null;
  totalPossiblePoints: number;
}

export interface IQuestionSubmissionsByCourseFormResult {
  id: string;
  userId: string;
  answers: string[];
  state: QuestionSubmissionState;
  scoreBeforeRegrade: number;
  finalScore: number | null;
  remark: string | null;
  questionType: QuestionTypes;
}

export interface IFormSubmissionsByCourseFormResult {
  id: string;
  attempt: number;
  userId?: string;
  finishedAt?: Date;
  startedAt: Date;
  initialTotalScore: number;
  finalTotalScore: number | null;
  totalPossiblePoints: number;
}

export interface IFormSubmissionsByUserResult extends IFormSubmissionsByCourseFormResult {
  formTitle: string;
  formId: string;
  showAfterRegrade: boolean;
  showScore: boolean;
}

export interface IFormSubmissionQuestions {
  id: string;
  answers: string[];
  state: QuestionSubmissionState;
  scoreBeforeRegrade: number;
  finalScore: number | null;
  remark: string | null;
  question: {
    id: string;
    name: string;
    type: QuestionTypes;
    position: number;
    pointsPossible: number;
  }
}

export type INDEX_TO_LETTER_TYPE = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10
  | 11 | 12 | 13 | 14 | 15 | 16 | 17 | 18 | 19 | 20 | 21 | 22 | 23 | 24 | 25;

export const INDEX_TO_LETTER = {
  0: 'A',
  1: 'B',
  2: 'C',
  3: 'D',
  4: 'E',
  5: 'F',
  6: 'G',
  7: 'H',
  8: 'I',
  9: 'J',
  10: 'K',
  11: 'L',
  12: 'M',
  13: 'N',
  14: 'O',
  15: 'P',
  16: 'Q',
  17: 'R',
  18: 'S',
  19: 'T',
  20: 'U',
  21: 'V',
  22: 'W',
  23: 'X',
  24: 'Y',
  25: 'Z',
};
